/**
 * Format DB timestamps for Moldex admin UI (PH wall-clock display).
 * Handles Postgres ISO (2026-08-22T03:40:05.907Z) and legacy Supabase formats.
 */
export function formatPhDateTime(d) {
  if (!d) return '';

  try {
    const parsed = new Date(d);
    if (isNaN(parsed.getTime())) {
      console.error('Invalid date format:', d);
      return '';
    }

    const year = parsed.getUTCFullYear();
    const month = parsed.getUTCMonth();
    const day = parsed.getUTCDate();
    const hour = parsed.getUTCHours();
    const minute = parsed.getUTCMinutes();
    const second = parsed.getUTCSeconds();

    const displayDate = new Date(year, month, day, hour, minute, second);

    const migrationDate = new Date(2025, 2, 16);
    if (displayDate >= migrationDate) {
      displayDate.setHours(displayDate.getHours() + 8);
    }

    return displayDate.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  } catch (error) {
    console.error('Date conversion error for:', d, error);
    return '';
  }
}
